import React from 'react'

function Strengths() {
    return (
        <div className='min-h-[90vh] px-[100px] py-[50px]'>
            <h1 className='text-[3rem] text-[#5A6984]  font-bold poppins uppercase'>OUR STRENGTHS</h1>
            <div className='flex flex-col mt-10 gap-5'>
                <p className='text-left text-[1.2em]'>Experienced and competent team of 50+ professionals.</p>
                <p className='text-left text-[1.2em]'>Well-equipped high-end facilities in R&D, Electronics Manufacturing and Testing, Mechanical Manufacturing, Environmental Test Lab, QA and documentation.</p>
                <p className='text-left text-[1.2em]'>Manufacturing facility complaint with Defence manufacturing processes as per MIL/IPC Standards.</p>
                <p className='text-left text-[1.2em]'>More than 12 years of Experience of working with DRDO Labs, successfully delivered more than 80+ orders to various DRDO Labs, DPSU’s and private Defence organization.</p>
                <p className='text-left text-[1.2em]'>ToT holder of various products from TBRL-DRDO and NML Jameshdpur.</p>
                <p className='text-left text-[1.2em]'>To be future ready, Accelor has acquired land of 18000 sq. feet from Department of Industries Punjab to build a mass production unit with covered area of 24000 sq. feet. This new unit situated at Industrial Focal point near Air Force Station, Halwara, Punjab will be fully functional by 2025.</p>
            </div>
        </div>
    )
}

export default Strengths